import dayjs from 'dayjs';
import { isEmpty, isNil } from 'lodash';

import { SHORT_MONTH_DAY_YEAR_FORMAT } from 'constants/date';

import {
  LICENSE_EXPIRATION_FIELDS,
  LICENSE_EXPIRED_TITLE,
  LICENSE_RECERT_BY_PREFIX,
  NMLS_RECERT_LABEL,
} from './licenseCountdown.constants';

// Composes the chip title: "NMLS recert · N days" while valid, "NMLS recert ·
// expired" once the countdown reaches/passes zero.
export const getLicenseChipTitle = ({ label, daysRemaining }) =>
  daysRemaining <= 0 ? LICENSE_EXPIRED_TITLE : `${label} · ${daysRemaining} days`;

// As-of / freshness label for the chip tooltip — the soonest license expiry date.
export const getLicenseChipTooltip = ({ soonestExpirationDate }) =>
  `${LICENSE_RECERT_BY_PREFIX} ${soonestExpirationDate}`;

const getLicenseExpiration = license =>
  LICENSE_EXPIRATION_FIELDS.map(field => license?.[field]).find(value => !isNil(value)) ?? null;

// Reduces the company's state-license rows to a single NMLS-recert countdown driven
// by the soonest-expiring license. Returns null when no license is on file (chip is
// hidden / the strip shows its "no license on file" empty state).
export const mapCompanyLicenseSummary = (licenses = []) => {
  const expirationDates = licenses
    .map(getLicenseExpiration)
    .filter(value => !isNil(value))
    .map(value => dayjs(value));

  if (isEmpty(expirationDates)) {
    return null;
  }

  const soonest = expirationDates.reduce((min, date) => (date.isBefore(min) ? date : min));
  const daysRemaining = soonest.startOf('day').diff(dayjs().startOf('day'), 'day');

  return {
    label: NMLS_RECERT_LABEL,
    daysRemaining,
    soonestExpirationDate: soonest.format(SHORT_MONTH_DAY_YEAR_FORMAT),
  };
};
